export const tabNames = {
  person: 'person',
  company: 'company',
  genericLookup: 'genericLookup',
} as const
